module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-mask-model-rect-list-item"
  }, [_c('img', {
    staticClass: "user-mask-model-rect-list-item-img",
    attrs: {
      "src": _vm.data.backgroundUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-list-item-content"
  }, [_c('div', {
    staticClass: "user-mask-model-rect-list-item-content-name"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-list-item-content-fl"
  }, [_c('div', {
    staticClass: "user-mask-model-rect-list-item-content-fl-left"
  }, [_vm._v(_vm._s(_vm.data.categoryName))]), _vm._v(" "), (_vm.data.isOpenReplay == 1 && _vm.data.replayUrl) ? _c('div', {
    staticClass: "user-mask-model-rect-list-item-content-fl-right",
    on: {
      "click": function($event) {
        return _vm.handlePlayVideo(_vm.data.replayUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/huifang@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.huifang')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "user-mask-model-rect-list-item-content-time"
  }, [_vm._v(_vm._s(_vm.data.liveStartTime) + "-" + _vm._s(_vm.data.liveEndTime))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d73bdbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/zbjlItem/zbjlItem.vue
// module id = 994
// module chunks = 1